/** Read-only table of the CA certificates in a bundle, with per-row Remove. */

import type { ReactElement } from 'react';
import type { CertInfo } from '../../schemas/admin.schemas';

interface CaCertificateTableProps {
  certificates: CertInfo[];
  onRemove: (index: number) => void;
  disabled: boolean;
}

/** First 8 bytes of the colon-separated SHA-256, enough to tell certs apart. */
const shortFingerprint = (sha: string): string => `${sha.split(':').slice(0, 8).join(':')}…`;

export function CaCertificateTable({
  certificates, onRemove, disabled,
}: CaCertificateTableProps): ReactElement {
  if (certificates.length === 0) {
    return <p className="runtime-config__subtext">No CA certificates in the bundle.</p>;
  }
  return (
    <table className="runtime-config__ca-table">
      <thead>
        <tr>
          <th>Subject</th>
          <th>Issuer</th>
          <th>Expires</th>
          <th>SHA-256</th>
          <th><span className="sr-only">Actions</span></th>
        </tr>
      </thead>
      <tbody>
        {certificates.map((c, i) => (
          <tr key={`${c.sha256}:${String(i)}`}>
            <td>{c.subject}</td>
            <td>{c.issuer}</td>
            <td>
              {c.not_after.slice(0, 10)}
              {c.expired && <span className="runtime-config__badge runtime-config__badge--required"> Expired</span>}
              {!c.expired && c.expires_soon && (
                <span className="runtime-config__badge runtime-config__badge--unset"> Expires soon</span>
              )}
            </td>
            <td title={c.sha256}><code>{shortFingerprint(c.sha256)}</code></td>
            <td>
              <button
                type="button"
                className="feature-table__edit-btn feature-table__edit-btn--danger"
                disabled={disabled}
                onClick={() => { onRemove(i); }}
                aria-label={`Remove ${c.subject}`}
              >
                Remove
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
